<template>
  <div class="col-sm-12 routa-dark">
    <h1 class="title orange">{{ $t('menu.content') }}</h1>
    <b-row class="reference-container" align-h="center">
      <div class="col-sm-5">
        <span class="sub-title blue">{{ $t('content.web') }}</span>
        <p class="article-text light">{{ $t('content.web_descr') }}</p>
      </div>
      <div class="col-sm-5">
        <span class="sub-title blue">{{ $t('content.vehicle') }}</span>
        <p class="article-text light">{{ $t('content.vehicle_descr') }}</p>
      </div>
      <div class="col-sm-5">
        <span class="sub-title blue">{{ $t('content.recorder') }}</span>
        <p class="article-text light">{{ $t('content.recorder_descr') }}</p>
      </div>
      <div class="col-sm-5">
        <span class="sub-title blue">{{ $t('content.time') }}</span>
        <p class="article-text light">{{ $t('content.time_descr') }}</p>
      </div>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'Content',
  computed: {
    imgUrl() {
      return require('@/assets/devices.png')
    }
  }
}
</script>

